export default __webpack_public_path__ + "static/media/signature.cdd8fd6d.png";